import InvoiceInfo from "features/invoices/components/InvoiceInfo";
import RoundButton from "features/shared/components/buttons/RoundButton";
import PriceFormatter from "features/shared/components/formatters/PriceFormatter";
import React from "react";
import PaymentUsageDTO from "../dtos/PaymentUsageDTO";

import styles from "./paymentusagerow.module.scss";
import { PaymentType } from "../enums/paymentType";
import { getPaymentDetailRoute } from "features/shared/helpers/routeHelper";

interface IProps {
  paymentUsage: PaymentUsageDTO;
  paymentId: string;
  paymentType: PaymentType;
  showInvoiceTimePeriod?: boolean;
}

const PaymentUsageRow: React.FC<IProps> = (props) => {
  // props
  const { amount, invoiceUsage } = props.paymentUsage;

  // render
  return (
    <div className={styles.paymentDetailRow}>
      <div className="row align-items-center no-gutters">
        <div className="col">
          <div className="row no-gutters align-items-center">
            <div
              className={`d-none d-sm-block col-3 offset-1 align-self-stretch ${styles.paymentTreeItem}`}
            ></div>
            <div className="col-12 col-sm-3 pl-sm-3">
              <div className="d-flex flex-column">
                <div className="text-truncate">
                  <span className="">
                    <PriceFormatter
                      amount={amount!}
                      currency={invoiceUsage?.currency!}
                    />
                  </span>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-5 pl-sm-2 pl-xl-4">
              <InvoiceInfo
                invoiceType={invoiceUsage?.invoiceType!}
                invoiceSubType={invoiceUsage?.invoiceSubType!}
                commodityDetails={invoiceUsage?.commodityDetail!}
                entityLinks={invoiceUsage?.entityLinks!}
                timePeriodFrom={invoiceUsage?.timePeriodFrom}
                timePeriodTo={invoiceUsage?.timePeriodTo}
                mobileBehaviour
                showTimePeriod={props.showInvoiceTimePeriod}
              />
            </div>
          </div>
        </div>
        <div className="col-auto pl-2">
          <RoundButton asLink to={getPaymentDetailRoute(props.paymentType, props.paymentId)}/>
        </div>
      </div>
    </div>
  );
};

export default PaymentUsageRow;